module.exports = __webpack_public_path__ + "static/img/ytg.a587a8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ytg.png
// module id = T8Zm
// module chunks = 167